import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Group } from "./GroupConversation/index.jsx";
import { getAllUsers, getLoggedUserId } from "../../../../../store/selectors/selector.users.jsx";
import { getGroupConversationName } from "../../util.jsx";

export const GroupConversation = ({ members, name, conversationId, onLeave }) => {
  const users = useSelector(getAllUsers);
  const loggedUserId = useSelector(getLoggedUserId);

  const groupName = useMemo(() => {
    return getGroupConversationName(members, loggedUserId, users.toJS(), name);
  }, [members, name, users, loggedUserId]);

  return (
    <Group
      name={groupName}
      conversationId={conversationId}
      onLeave={onLeave}
    />
  );
};

GroupConversation.propTypes = {
  members: PropTypes.arrayOf(PropTypes.number),
  name: PropTypes.string,
  onLeave: PropTypes.func,
  conversationId: PropTypes.number,
};

GroupConversation.defaultProps = {
  members: [],
  name: "",
};
